import { useEffect, useState } from "react";
import { CheckCircle2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card, Loader } from "@/components/portal/ui";

export function SecurityLog() {
  const { t } = useI18n();
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/control/security-log").then(({ data }) => setItems(data)); }, []);
  if (!items) return <Loader />;
  return (
    <div className="kw-fade">
      <h1 className="font-heading text-3xl font-bold mb-6" style={{ color: "var(--text)" }}>{t("control.security")}</h1>
      <Card className="divide-y" data-testid="security-log-list">
        {items.length === 0 && <div className="p-8 text-center text-sm" style={{ color: "var(--text-muted)" }}>{t("common.none")}</div>}
        {items.map((s) => {
          const ok = s.ok ?? s.success ?? true;
          return (
            <div key={s.id} className="p-4 flex flex-wrap items-center gap-3 text-sm" style={{ borderColor: "var(--border)" }} data-testid={`security-row-${s.id}`}>
              {ok ? <CheckCircle2 className="h-4 w-4 shrink-0" style={{ color: "#15803D" }} /> : <XCircle className="h-4 w-4 shrink-0" style={{ color: "#B91C1C" }} />}
              <span className="font-medium" style={{ color: "var(--text)" }}>{s.event}</span>
              <span style={{ color: "var(--text-muted)" }}>{s.email}</span>
              {s.portal_key && <span className="text-xs uppercase tracking-widest px-2 py-0.5 rounded-full" style={{ background: "var(--surface-alt)", color: "var(--text-muted)" }}>{s.portal_key}</span>}
              <span className="hidden sm:block text-xs truncate max-w-[200px]" style={{ color: "var(--text-muted)" }}>{s.ip}</span>
              <span className="ml-auto text-xs whitespace-nowrap" style={{ color: "var(--text-muted)" }}>{new Date(s.created_at).toLocaleString()}</span>
            </div>
          );
        })}
      </Card>
    </div>
  );
}
